export const LAYOUT_MOBILE_BREAKPOINT_PX: number = 576;
export const LAYOUT_MOBILE_MAX_MEDIA_QUERY: string = `(max-width: ${LAYOUT_MOBILE_BREAKPOINT_PX}px)`;
export const LAYOUT_MOBILE_MIN_MEDIA_QUERY: string = `(min-width: ${LAYOUT_MOBILE_BREAKPOINT_PX}px)`;

export const LAYOUT_DESKTOP_BREAKPOINT_PX: number = 992;
export const LAYOUT_DESKTOP_MIN_MEDIA_QUERY: string = `(min-width: ${LAYOUT_DESKTOP_BREAKPOINT_PX}px)`;
export const LAYOUT_DESKTOP_MAX_MEDIA_QUERY: string = `(max-width: ${LAYOUT_DESKTOP_BREAKPOINT_PX - 0.02}px)`;
